// src/actions/collectionActions.js
import {
  FETCH_COLLECTIONS_REQUEST,
  FETCH_COLLECTIONS_SUCCESS,
  FETCH_COLLECTIONS_FAILURE,
  CREATE_COLLECTION_REQUEST,
  CREATE_COLLECTION_SUCCESS,
  CREATE_COLLECTION_FAILURE,
  UPDATE_COLLECTION_REQUEST,
  UPDATE_COLLECTION_SUCCESS,
  UPDATE_COLLECTION_FAILURE,
  DELETE_COLLECTION_REQUEST,
  DELETE_COLLECTION_SUCCESS,
  DELETE_COLLECTION_FAILURE,
} from "./types";

export const fetchCollectionsRequest = (payload) => ({
  type: FETCH_COLLECTIONS_REQUEST,
  payload,
});

export const fetchCollectionsSuccess = (collections) => ({
  type: FETCH_COLLECTIONS_SUCCESS,
  payload: collections,
});

export const fetchCollectionsFailure = (error) => ({
  type: FETCH_COLLECTIONS_FAILURE,
  payload: error,
});

export const createCollectionRequest = (payload) => ({
  type: CREATE_COLLECTION_REQUEST,
  payload,
});

export const createCollectionSuccess = (collection) => ({
  type: CREATE_COLLECTION_SUCCESS,
  payload: collection,
});

export const createCollectionFailure = (error) => ({
  type: CREATE_COLLECTION_FAILURE,
  payload: error,
});

export const updateCollectionRequest = (payload) => ({
  type: UPDATE_COLLECTION_REQUEST,
  payload,
});

export const updateCollectionSuccess = (collection) => ({
  type: UPDATE_COLLECTION_SUCCESS,
  payload: collection,
});

export const updateCollectionFailure = (error) => ({
  type: UPDATE_COLLECTION_FAILURE,
  payload: error,
});

export const deleteCollectionRequest = (payload) => ({
  type: DELETE_COLLECTION_REQUEST,
  payload,
});

export const deleteCollectionSuccess = (slug) => ({
  type: DELETE_COLLECTION_SUCCESS,
  payload: slug,
});

export const deleteCollectionFailure = (error) => ({
  type: DELETE_COLLECTION_FAILURE,
  payload: error,
});
